import { api } from "@/api"

export const sendUserLoginLink = async (userId: string) =>
  await api.post(`/users/${userId}/send-login-link/`)
